// Returns a new categories array with `menuItem` moved to `targetCategoryId`, carrying its image across.
// Builds copies only: the input comes straight from the Redux store and must not be mutated.
// Returns null when there is nothing to move (unknown category, or the item is already in the target).
export const moveMenuItemToCategory = (categories, menuItem, targetCategoryId) => {
  const currentCategory = categories.find(c => c.id === menuItem.categoryId);
  const targetCategory = categories.find(c => c.id === targetCategoryId);
  if (!currentCategory || !targetCategory || currentCategory.id === targetCategory.id) {
    return null;
  }

  const currentImages = { ...(currentCategory.images || {}) };
  const image = currentImages[menuItem.id];
  delete currentImages[menuItem.id];

  const targetImages = { ...(targetCategory.images || {}) };
  if (image) {
    targetImages[menuItem.id] = image;
  }

  const currentCategoryData = {
    ...currentCategory,
    items: (currentCategory.items || []).filter(item => item.id !== menuItem.id),
    images: currentImages,
  };
  const targetCategoryData = {
    ...targetCategory,
    items: [...(targetCategory.items || []), { ...menuItem, categoryId: targetCategory.id }],
    images: targetImages,
  };

  return categories.map(c => {
    if (c.id === currentCategory.id) {
      return currentCategoryData;
    }
    if (c.id === targetCategory.id) {
      return targetCategoryData;
    }
    return c;
  });
};
